import React from "react";
import { ToastProvider } from "./components/Toast";
import Topbar from "./components/Topbar";
import Hero from "./components/Hero";
import QuienesSomos from "./components/QuienesSomos";
import VisionMision from "./components/VisionMision";
import Calendario from "./components/Calendario";
import Menu from "./components/Menu";
import Galeria from "./components/Galeria";
import Contacto from "./components/Contacto";
import Footer from "./components/Footer";

export default function Site() {
  return (
    <ToastProvider>
      <div className="backdrop"><div className="vignette" /></div>
      <Topbar />
      <main>
        <Hero />
        <QuienesSomos />
        <VisionMision />
        <Calendario />
        <Menu />
        <Galeria />
        <Contacto />
      </main>
      <Footer />
    </ToastProvider>
  );
}
